import { StepFieldInterface } from '../../../../modals/step-validation';

export const fieldsDescription = {
  ownership_type: {
    step: 1,
    sectionName: 'Основная информация',
    fieldName: 'Форма юр. лица',
  },
  ps_name: {
    step: 1,
    sectionName: 'Основная информация',
    fieldName: 'Наименование',
  },
  legal_postcode: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Юридический',
    fieldName: 'Индекс',
  },
  la_country: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Юридический',
    fieldName: 'Страна',
  },
  la_region_name: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Юридический',
    fieldName: 'Область',
  },
  la_city_name: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Юридический',
    fieldName: 'Город',
  },
  la_street_type: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Юридический',
    fieldName: 'Тип улицы',
  },
  la_street_name: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Юридический',
    fieldName: 'Улица',
  },
  la_house_number: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Юридический',
    fieldName: 'Дом',
  },
  physical_postcode: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Фактический',
    fieldName: 'Индекс',
  },
  pa_country: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Фактический',
    fieldName: 'Страна',
  },
  pa_region_name: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Фактический',
    fieldName: 'Область',
  },
  pa_city_name: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Фактический',
    fieldName: 'Город',
  },
  pa_street_type: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Фактический',
    fieldName: 'Тип улицы',
  },
  pa_street_name: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Фактический',
    fieldName: 'Улица',
  },
  pa_house_number: {
    step: 1,
    sectionName: 'Адреса',
    subSectionName: 'Фактический',
    fieldName: 'Дом',
  },
  ps_contract: { step: 2, sectionName: 'Договор', fieldName: 'Номер' },
  effective_date: {
    step: 2,
    sectionName: 'Договор',
    fieldName: 'Период действия(Начало периода)',
  },
  expiration_date: {
    step: 2,
    sectionName: 'Договор',
    fieldName: 'Период действия(Конец периода)',
  },
  domains: {
    step: 2,
    sectionName: 'Дополнительные настройки',
    fieldName: 'Домены электронной почты компании',
  },
  partner_code: {
    step: 2,
    sectionName: 'Дополнительные настройки',
    fieldName: 'Код партнера',
  },
};

export interface CompaniesStepFieldsValidationInterface {
  ownership_type: StepFieldInterface;
  ps_name: StepFieldInterface;
  legal_postcode: StepFieldInterface;
  la_country: StepFieldInterface;
  la_region_name: StepFieldInterface;
  la_city_name: StepFieldInterface;
  la_street_type: StepFieldInterface;
  la_street_name: StepFieldInterface;
  la_house_number: StepFieldInterface;
  physical_postcode: StepFieldInterface;
  pa_country: StepFieldInterface;
  pa_region_name: StepFieldInterface;
  pa_city_name: StepFieldInterface;
  pa_street_type: StepFieldInterface;
  pa_street_name: StepFieldInterface;
  pa_house_number: StepFieldInterface;
  ps_contract: StepFieldInterface;
  effective_date: StepFieldInterface;
  expiration_date: StepFieldInterface;
  domains: StepFieldInterface;
  partner_code: StepFieldInterface;
}
